/* ============================================================
   CLARITY · Kollagenberater in der Navigation verankern
   Angelegt 29.08.2026.

   WARUM: Der schwebende Reiter war auf dem iPhone nicht zuverlassig
   zu treffen und kollidierte an einem Vormittag dreimal mit anderen
   Elementen (Cookie-Knopf, Warenkorb-Schublade, untere Leiste).
   Ein schwebendes Element konkurriert dauerhaft mit Systemgesten und
   fremden Overlays. Deshalb ist er ersatzlos abgeschaltet.

   STATTDESSEN sitzt der Berater dort, wo die Navigation ohnehin ist:
     Telefon    Feld "Berater" in der unteren Leiste (mobile-dock)
     Desktop    Knopf in der Kopfzeile, links neben dem Warenkorb
     ueberall   Kachel im Footer neben ChatGPT/Claude/Grok/Perplexity

   Der Kopfzeilen-Knopf hat einen Nebeneffekt, der ausdrucklich
   gewollt ist: Die Warenkorb-Schublade legt sich uber die Kopfzeile.
   Sobald der Warenkorb offen ist, ist der Berater damit von selbst
   verschwunden - ohne Extraregel.

   🔑 GEMESSEN 29.08., wichtig fuer spatere Anderungen:
   1) Die Klasse .ch-solid gibt es NICHT auf jeder Seite - auf /cart
      ja, auf der Startseite nicht. Verlasslicher Anker ist
      div.ch-right, der rechte Block der Kopfzeile.
   2) Die Footer-Kacheln in .cf-ai-row sind 52 x 52 px und enthalten
      IMMER zwei Kinder: ein <svg> und ein <span class="cf-ai-name">.
      Ein Eintrag mit blossem Text sprengt die Kachel - der erste
      Versuch lief quer ueber die Nachbarkacheln.

   RUECKBAU: die script-Zeile in snippets/clarity-ci-css.liquid
   entfernen, in clarity-fix-2908.css Block 3 loschen und den
   Leisten-Block in sections/overlay-group.json auf "account" stellen.
   ============================================================ */

(function () {
  'use strict';

  var ZIEL = 'kollagenberater';
  var NAME = 'Kollagenberater';
  var BREIT = 761;   // ab hier gilt die Kopfzeile statt der Leiste

  /* ------------------------------------------------------------
     Das Zeichen: Ĉ mit Funke — von Marcus gewaehlt am 29.08.2026.

     Grundlage ist das Zirkumflex-C der Wortmarke, das sonst niemand
     fuehrt. Der feine Vierstrahl daneben steht fuer die KI, ohne dass
     irgendwo "AI" geschrieben werden muss. Eine Sprechblase waere
     austauschbar gewesen - die benutzt jeder Chatdienst.

     Fassung 29.08.2026 (Marcus' Wahl, Variante 05): Strahlenkranz im
     C statt einzelnem Funken, drei Sterne aussen. Das Zirkumflex ist
     dafuer entfallen - der Kranz braucht den Innenraum.
     ACHTUNG, gemessen: Bei 21 px liegen acht Strahlen auf rund 9 px
     Innenflaeche und die Sterne sind je 2 px gross. Das Zeichen ist
     dort deutlich unruhiger als die Vorgaengerfassung. Bewusst so
     entschieden. Vorgaenger steht in
     ~/.claude/backups/clarity-live-200258093403-20260829-icon05/.
     ------------------------------------------------------------ */
  var PFAD =
    '<path d="M17.5 7.5a7 7 0 1 0 0 9"/>' +           /* der C-Bogen        */
    /* Strahlenkranz im Innenraum - acht Strahlen, gold.
       JEDER Goldpfad braucht class="cl-funke": die Regel
       "#cl-berater-kopf svg path:not(.cl-funke)" in
       clarity-berater-orte.css faerbt sonst alles Off-White. */
    '<path class="cl-funke" stroke="#C4A882" stroke-width="1.1"' +
    ' d="M14.3 12H16.7M12.1 9.8V7.4M9.9 12H7.5M12.1 14.2V16.6"/>' +
    '<path class="cl-funke" stroke="#C4A882" stroke-width="1.1"' +
    ' d="M13.7 10.4 15.4 8.7M10.5 10.4 8.8 8.7M10.5 13.6 8.8 15.3M13.7 13.6 15.4 15.3"/>' +
    /* drei Sterne aussen */
    '<path class="cl-funke" stroke="#C4A882" stroke-width="1"' +
    ' d="M21 2.2v2M20 3.2h2M3.4 6.2v1.6M2.6 7h1.6M20.4 19v1.8M19.5 19.9h1.8"/>';

  function zeichen(klasse, groesse) {
    return '<svg class="' + klasse + '"' +
      (groesse ? ' width="' + groesse + '" height="' + groesse + '"' : '') +
      ' viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"' +
      ' stroke-linecap="round" stroke-linejoin="round"' +
      ' xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      PFAD + '</svg>';
  }

  var SYMBOL_KOPF = zeichen('icon icon-advisor', 24);
  var SYMBOL_FUSS = zeichen('', null);   /* Groesse setzt die Kachel-CSS */

  function beraterKnopf() {
    return document.querySelector('#cl-adv .adv-open');
  }

  /* --- 1 · Jeder Verweis auf #kollagenberater oeffnet den Berater --- */
  function aufKlick(ereignis) {
    var ziel = ereignis.target;
    if (!ziel || !ziel.closest) return;

    var link = ziel.closest('a[href*="' + ZIEL + '"]');
    if (!link) return;

    ereignis.preventDefault();
    ereignis.stopPropagation();

    var knopf = beraterKnopf();
    if (knopf) knopf.click();
  }

  /* --- 2 · Knopf in die Kopfzeile, links neben den Warenkorb ------- */
  function inKopfzeile() {
    if (window.innerWidth < BREIT) return;
    if (document.getElementById('cl-berater-kopf')) return;

    var rechts = document.querySelector('.ch-right');
    if (!rechts) return;

    var warenkorb = rechts.querySelector('cart-drawer, .cart-drawer-container');

    var a = document.createElement('a');
    a.id = 'cl-berater-kopf';
    a.className = 'header__icon ch-iconbtn focus-inset';
    a.href = '#' + ZIEL;
    a.setAttribute('aria-label', NAME);
    a.setAttribute('title', NAME);
    /* Ein Symbol allein traegt keine Bedeutung, die man nicht schon
       kennt - Marcus, 29.08.: "Wenn du nicht wissen wuerdest, was alles
       geht, wuerdest du darauf klicken?" Deshalb steht der Name daneben,
       in der Label-Sprache der CI (DM Mono, Versalien, weiter Abstand). */
    a.innerHTML = SYMBOL_KOPF + '<span class="cl-berater-wort">' + NAME + '</span>';

    if (warenkorb) {
      rechts.insertBefore(a, warenkorb);
    } else {
      rechts.appendChild(a);
    }
  }

  /* --- 3 · Kachel im Footer neben den anderen KI-Werkzeugen -------- */
  function inFooter() {
    var reihe = document.querySelector('.cf-ai-row');
    if (!reihe) return;
    if (reihe.querySelector('[data-cl-berater]')) return;

    // Vorlage nehmen, damit Schrift, Rahmen und Zustaende stimmen.
    var vorlage = reihe.querySelector('a');
    var a = document.createElement('a');
    if (vorlage && vorlage.className) a.className = vorlage.className;
    a.setAttribute('data-cl-berater', '');
    a.href = '#' + ZIEL;
    a.setAttribute('aria-label', NAME);
    a.setAttribute('title', NAME);

    // Gleicher Aufbau wie die Nachbarn: Symbol + Namensfeld.
    a.innerHTML = SYMBOL_FUSS + '<span class="cf-ai-name">' + NAME + '</span>';

    reihe.appendChild(a);
  }

  function aufbauen() {
    inKopfzeile();
    inFooter();
  }

  document.addEventListener('click', aufKlick, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aufbauen);
  } else {
    aufbauen();
  }

  var zeitgeber = null;
  window.addEventListener('resize', function () {
    clearTimeout(zeitgeber);
    zeitgeber = setTimeout(aufbauen, 200);
  });

  /* --- 4 · Direkt geoeffnet ankommen (26.09.2026) -------------------
     Marcus: Wer in einer Mail auf den KI-Berater klickt, soll direkt im
     Berater landen, nicht nur auf der Startseite. Die Mail-Links zeigen
     auf claritycollagen.de/#kollagenberater. Der Berater selbst laedt
     spaeter als der Rest der Seite, deshalb wird bis zu 8 s nach dem
     Knopf gesucht. Danach verschwindet das #kollagenberater aus der
     Adresse, damit ein Neuladen ihn nicht erneut aufreisst.
     Funktioniert auch mit ?berater=1 (falls ein Mailprogramm den
     #-Teil abschneidet). */
  function sollOeffnen() {
    return window.location.hash === '#' + ZIEL ||
      /[?&]berater=1(&|$)/.test(window.location.search);
  }

  function direktOeffnen() {
    if (!sollOeffnen()) return;
    var versuche = 0;
    var takt = setInterval(function () {
      var knopf = beraterKnopf();
      versuche++;
      if (knopf) {
        clearInterval(takt);
        knopf.click();
        if (window.history && window.history.replaceState) {
          var sauber = window.location.pathname +
            window.location.search.replace(/([?&])berater=1(&|$)/, '$1').replace(/[?&]$/, '');
          window.history.replaceState(null, '', sauber);
        }
      } else if (versuche >= 40) {
        clearInterval(takt);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', direktOeffnen);
  } else {
    direktOeffnen();
  }
  window.addEventListener('hashchange', direktOeffnen);
})();
